import flow from 'lodash/flow';
import mapValues from 'lodash/mapValues';
import { normalizeSheet, getSheet, mapToJson } from '../../utils/readXlsxFile.utils';
import readXlsxFile from '../../utils/readXlsxFile';

export default async ({
  file,
  fileValidators = [],
  prevalidators = [],
  postvalidators = [],
  preprocessors = [],
  postprocessors = [],
  validationData = {},
  sheetName = '',
  fieldMappings = {},
  fieldParsers = null,
  fieldNormalizers = null,
  getRange = null,
  mapToJsonOptions = {},
}) => {
  await Promise.all(fileValidators.map(validator => validator(file, validationData)));

  const workbook = await readXlsxFile(file);

  // Additional security validation
  if (workbook && typeof workbook === 'object') {
    // Check for suspicious properties that could indicate prototype pollution attempts
    const suspiciousKeys = ['__proto__', 'constructor', 'prototype'];
    const hasSuspiciousKeys = Object.keys(workbook).some(key => suspiciousKeys.includes(key));
    if (hasSuspiciousKeys) {
      throw new Error('Invalid file content detected');
    }
  }

  const sheetToBeMappedRaw = getSheet(workbook, sheetName);

  await Promise.all(prevalidators.map(validator => validator(workbook, validationData)));

  const sheetToBeMapped = fieldNormalizers ? normalizeSheet(fieldNormalizers)(sheetToBeMappedRaw) : sheetToBeMappedRaw;

  const rangeToBeMapped = getRange
    ? getRange(sheetToBeMapped)
    : sheetToBeMapped['!ref'];

  const sheetAsJson = mapToJson({
    sheet: sheetToBeMapped,
    fieldMappings,
    fieldParsers,
    options: {
      raw: true,
      range: rangeToBeMapped,
      ...mapToJsonOptions,
    },
  });

  const trimmedSheet = sheetAsJson.map(row => mapValues(row,
    value => (value && value.trim) ? value.trim() : value
  ));

  const preprocessedRows = flow(preprocessors)(trimmedSheet);

  await Promise.all(postvalidators.map(validator => validator(preprocessedRows, validationData)));

  const postprocessedRows = flow(postprocessors)(preprocessedRows);

  return postprocessedRows;
};
